module.exports = __webpack_public_path__ + "media/images/athletes/3407-d7da6544717633e17b3114919d6af98c.png";